import React, { useRef, useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Preloader from "../Miscellaneous/Preloader";
import Footer from "../Footer/Footer";
import customersData from "../../data/customersData.json";

const cardBgColors = [
  "#F5F5F5", "#F5F5F5", "#F5F5F5",
  "#EAF7FF", "#EAF7FF", "#EAF7FF",
  "#F5F5F5", "#F5F5F5", "#F5F5F5",
  "#FBE2EC", "#FBE2EC", "#FBE2EC",
  "#F5F5F5", "#F5F5F5", "#F5F5F5",
  "#F6E1D6", "#F6E1D6", "#F6E1D6",
  "#F5F5F5", "#F5F5F5", "#F5F5F5",
  "#EFFDEB", "#EFFDEB", "#EFFDEB",
];

const Customers = () => {
  const { customerName } = useParams();
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 0);
    });
  }, [location.pathname]);

  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  const introText = customerName ? (
    <>CUSTOMERS / <strong>{decodeURIComponent(customerName)}</strong></>
  ) : (
    <>CUSTOMERS / <strong> CASE STUDY</strong></>
  );

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  const getResponsivePadding = () => {
    if (isMobile) return 20;
    if (isTablet) return 40;
    return 60;
  };

  const paddingInline = getResponsivePadding();
  const [activeIndex, setActiveIndex] = useState(0);

  const solutions = [
    { text: "Market Quality AI Agent", },
    { text: "Quality Enhancement" },
    { text: "Vehicle Reliability" },
    { text: "BOM Analytics" },
    { text: "Road Condition Monitoring" },
    { text: "SDV Capabilities" },
    { text: "Delivery Process" },
    { text: "Emission Compliance" },
  ];

  const sectionRefs = useRef(solutions.map(() => React.createRef()));

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [vw, setVw] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const isMob = vw < 1024;

  if (!customersData || customersData.length === 0) {
    return <div style={{ backgroundColor: "#e80c0cff", height: "100vh" }} />;
  }

  return (
    <>
      <Preloader />
      <Header />
      {/* Hero Section */}
      <section style={{ backgroundColor: "#BDEDB2", paddingInline: `${paddingInline}px`, paddingTop: "95px", paddingBottom: "0px", display: "flex", flexDirection: "column", alignItems: "center", }}>
        <div className="headerWd" style={{ marginTop: isMob ? "64px" : "" }}>
          <span style={{ fontSize: isMob ? "25px" : "16px", color: "#000000", }}>{introText}</span>
          {/* Outer Green Card */}
          <div style={{
            backgroundColor: "#88C4A0", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", padding: isMobile ? "30px 20px 0 20px" : isTablet ? "50px 40px 0 40px" : "70px 70px 0 70px",
            marginTop: isMob ? "50px" : "40px"
          }} >
            <div style={{ backgroundColor: "#FFFFFF80", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", padding: "10px 10px 0 10px", }}>
              {/* Inner White Card */}
              <div style={{ backgroundColor: "#FFFFFF", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", padding: isMobile ? "20px 16px" : isTablet ? "30px 24px" : "40px 38px", }}>
                {/* Heading */}
                <h2 style={{ fontSize: isMob ? "53px" : "32px", fontWeight: "700", color: "#000", lineHeight: isMob ? "165%" : "130%", letterSpacing: "0%" }}>
                  <span style={{ color: "#E61C83" }}>Ravity</span>{" "}
                  Delivering value across automotive value chain
                </h2>

                {/* Client */}
                <p style={{ fontSize: isMob ? "43px" : "20px", color: "#000", fontWeight: "400", marginTop: "16px", lineHeight: isMob ? "75px" : "32px", letterSpacing: "0%" }}>
                  <strong>Client</strong> : Mobility companies across India, Europe, UK and Africa
                </p>

                {/* Problem Statement */}
                <div style={{ marginTop: "20px" }}>
                  <p style={{ fontSize: isMob ? "45px" : "20px", color: "#000", fontWeight: "700", marginTop: "16px", lineHeight: isMob ? "75px" : "32px", letterSpacing: "0%" }}>
                    Problem Statement
                  </p>
                  <p style={{ fontSize: isMob ? "38px" : "20px", color: "#000", fontWeight: "400", marginTop: "16px", lineHeight: isMob ? "75px" : "32px", letterSpacing: "0%" }}>
                    Deliver value from connected vehicle data beyond the B2C Application
                  </p>
                </div>

                {/* Solutions */}
                <div style={{ marginTop: "28px" }}>
                  <p style={{ fontSize: isMob ? "43px" : "20px", color: "#000", fontWeight: "700", marginTop: "16px", lineHeight: isMob ? "75px" : "32px", letterSpacing: "0%", marginBottom: "20px" }}>
                    Solutions:
                  </p>

                  {/* Grid */}
                  <div style={{ display: "grid", gridTemplateColumns: isMob ? "1fr" : "1fr 1fr", gap: isMob ? "40px" : "20px 40px", }}>
                    {solutions.map((sol, index) => {
                      const isActive = activeIndex === index;
                      return (
                        <div key={index}
                          onClick={() => {
                            setActiveIndex(index);
                            sectionRefs.current[index].current?.scrollIntoView({ behavior: "smooth" });
                          }}
                          style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", cursor: "pointer", }}>
                          {/* Row: Icon and Text */}
                          <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%", }}>
                            {/* Icon with gray circle */}
                            <div style={{ width: isMob ? "65px" : "40px", height: isMob ? "65px" : "40px", borderRadius: "50%", backgroundColor: "#F0F0F0", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, }}>
                              <img src="../img/caseStudies1.png" alt="icon"
                                style={{ width: isMob ? "40px" : "25px", height: isMob ? "40px" : "26px" }}
                              />
                            </div>

                            {/* Text */}
                            <span style={{ fontSize: isMob ? "32px" : "20px", fontWeight: 400, color: isActive ? "#5D5D5D" : "#000", lineHeight: isMob ? "60px" : "32px", letterSpacing: "0%", flex: 1, }}>
                              {sol.text}
                            </span>
                          </div>

                          {/* Underline Image (visible only if active) */}
                          {isActive && (
                            <img src="../img/borderLine.png" alt="active underline"
                              style={{
                                width: isMob ? "50%" : "40%",
                                height: isMob ? "8px" : "4px",
                                marginTop: "0px",
                                marginLeft: isMob ? "75px" : "50px"
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Content */}
      {customersData.map((section, idx) => (
        <section id={`section-${idx}`} key={idx} ref={sectionRefs.current[idx]}
          style={{ backgroundColor: section.bgColor, paddingBlock: isMobile ? "40px" : "70px", paddingInline: `${paddingInline}px`, }}>
          <div className="headerWd">
            <div style={{ display: "flex", gap: "8px", alignItems: "flex-start", }}>
              <div style={{
                writingMode: "vertical-lr",
                transform: "rotate(180deg)",
                WebkitTextStroke: "1px",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "var(--primary-t-color)",
                fontSize: isMob ? "60px" : "48px",
                fontWeight: "600",
              }}
              >
                {section.number}
              </div>

              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", marginBottom: "20px", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", }}>
                  <h2 style={{ fontSize: isMob ? "45px" : "42px", fontWeight: "700", color: "#F00D69", margin: 0, paddingRight: isMobile ? "0" : "10px", }}>
                    {section.title}
                  </h2>
                  {section.subtitle && (
                    <p style={{ fontSize: isMob ? "45px" : "42px", fontWeight: "700", color: "#000", margin: 0, marginTop: isMobile ? "0" : "-5px", }}>
                      {section.subtitle}
                    </p>
                  )}
                </div>

                {section.Client && (
                  <p style={{ fontSize: isMob ? "43px" : "24px", fontWeight: "400", marginBottom: "20px", color: "#000" }}>
                    {section.Client}
                  </p>
                )}

                {section.ProblemStatement && (
                  <div style={{ marginBottom: "30px" }}>
                    <p style={{ fontSize: isMob ? "45px" : "24px", fontWeight: "700", color: "#000", marginBottom: "8px" }}>
                      {section.ProblemStatement.split(":")[0]}
                    </p>
                    <p style={{ fontSize: isMob ? "38px" : "24px", fontWeight: "400", color: "#000", margin: 0 }}>
                      {section.ProblemStatement.split(":")[1]}
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "flex-start", marginTop: "40px", }}>
              {section.cards.map((card, i) => {
                const cardIndex = idx * 3 + i;
                return (
                  <div key={i}
                    style={{
                      padding: isMobile ? "16px" : "20px",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      background: cardBgColors[cardIndex] || "#ECEAEB80",
                      width: isMob ? "100%" : isTablet ? "calc(50% - 10px)" : "calc(33.33% - 13.33px)",
                      minWidth: isMobile ? "auto" : "280px",
                      textAlign: "center",
                      height: "auto",
                      flexGrow: isMobile ? 0 : 1,
                      marginTop: isMob ? "40px" : ""
                    }}
                  >
                    <img src={card.icon} alt={card.heading}
                      style={{ width: isMob ? "80px" : "55px", height: isMob ? "80px" : "55px", marginTop: isMob ? "40px" : "0px" }}
                    />
                    <h4 style={{ fontSize: isMob ? "34px" : "24px", fontWeight: "600", marginBottom: "8px", color: "#000", textAlign: "center", }}>
                      {card.heading}
                    </h4>
                    {card.description.includes("\n") ? (
                      <ul style={{ padding: isMobile ? "0px 20px 0px 20px" : "0px 40px 0px 40px", marginTop: isMob ? "70px" : "20px", marginBottom: isMob ? "50px" : "", textAlign: "left", fontWeight: "400", fontSize: isMobile ? "14px" : "18px", lineHeight: "100%", letterSpacing: "0%", textAlign: "justify", }}
                        className="custom-small-bullets"
                      >
                        {card.description.split("\n").map((line, idx) => (
                          <li key={idx} style={{
                            fontSize: isMob ? "2.3rem" : "",
                            lineHeight: isMob ? "1.9" : ""
                          }}
                          >{line.trim()}</li>
                        ))}
                      </ul>
                    ) : (
                      <p style={{ fontSize: isMob ? "14px" : "18px", color: "#333" }}>
                        {card.description}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      ))}
      <Footer />
    </>
  );
};

export default Customers;